<app-top-menu></app-top-menu>
<section class="hero-section">
    <div class="container">
        <div class="row align-items-center gy-5">
            <!-- Left Content -->
            <div class="col-lg-6">
                <h1 
                    class="display-4 mb-1" 
                    style="color: #024423; font-weight: 900; font-size: 5rem;"
                    data-aos="fade-right"
                    data-aos-delay="100">
                    VAIDS 2026
                </h1>
                <h4 
                    class="fw-semibold mb-3" 
                    style="color: #3C3F64;"
                    data-aos="fade-right"
                    data-aos-delay="200">
                    Voluntary Assets, Income Declaration & Tax Regularisation Scheme
                </h4>
                <div 
                    class="mb-4 fw-light" 
                    style="color: #6B7280; font-size: 18px;"
                    data-aos="fade-right"
                    data-aos-delay="300">
                    <p>
                        This FAQ is intended to guide taxpayers, tax practitioners,
                        and the general public on the operation, benefits and
                        requirements of the scheme. 
                    </p>
                    <p>
                        Get official answers on regularising your tax status in 
                        Anambra State under the new scheme window. A time-limited 
                        opportunity to regularise your tax position. July 6 — September 5, 2026.
                    </p>
                </div>
                <a 
                    [routerLink]="'/user/vaids'" 
                    class="cta-btn btn px-4 py-3 rounded-2 fs-16 d-flex align-items-center justify-content-center gap-3" 
                    data-aos="fade-right"
                    data-aos-delay="400">
                    <p class="mb-0">Get Started Now</p>
                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.22656 10.7643H16.7865M10.5065 17.0443L16.7865 10.7643L10.5065 4.48438" stroke="white" stroke-width="1.53795" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </a>
            </div>

            <!-- Illustration -->
            <div class="col-lg-6">
                <div 
                    class="hero-illustration"
                    data-aos="fade-down"
                    data-aos-delay="100">
                    <img
                        src="/assets/svg/vaids-illustration-1.svg"
                        class="img-fluid"
                        alt="VAIDS Illustration">
                </div>

                <!-- Statistics -->
                <div class="row justify-content-center mt-1 g-3">
                    <div class="col-md-4">
                        <div 
                            class="stat-card"
                            data-aos="zoom-in"
                            data-aos-delay="100">
                            <div class="icon-wrapper">
                                <svg class="icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_2491_91400)">
                                        <path d="M14.4075 6.60242C14.7091 8.08218 14.4942 9.62059 13.7987 10.9611C13.1032 12.3016 11.9692 13.3632 10.5858 13.9688C9.2024 14.5744 7.65317 14.6874 6.1965 14.289C4.73982 13.8906 3.46375 13.0049 2.58108 11.7795C1.69841 10.5542 1.26251 9.06324 1.34605 7.55538C1.4296 6.04752 2.02755 4.61388 3.04019 3.49353C4.05282 2.37318 5.41893 1.63384 6.91071 1.39882C8.40248 1.16379 9.92973 1.44728 11.2378 2.20201M5.95598 7.26265L7.93665 9.24333L14.5389 2.64106" stroke="#008000" stroke-width="1.32045" stroke-linecap="round" stroke-linejoin="round"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_2491_91400">
                                            <rect width="15.8454" height="15.8454" fill="white"/>
                                        </clipPath>
                                    </defs>
                                </svg>
                            </div>

                            <div>
                                <h5 style="font-size: 1rem; font-weight: 500;">2 Months</h5>
                                <small>Window Period</small>
                            </div>
                        </div>
                    </div>
    
                    <div class="col-md-4">
                        <div 
                            class="stat-card yellow"
                            data-aos="zoom-in"
                            data-aos-delay="200">
                            <div class="icon-wrapper">
                                <svg class="icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_2491_91400)">
                                        <path d="M14.4075 6.60242C14.7091 8.08218 14.4942 9.62059 13.7987 10.9611C13.1032 12.3016 11.9692 13.3632 10.5858 13.9688C9.2024 14.5744 7.65317 14.6874 6.1965 14.289C4.73982 13.8906 3.46375 13.0049 2.58108 11.7795C1.69841 10.5542 1.26251 9.06324 1.34605 7.55538C1.4296 6.04752 2.02755 4.61388 3.04019 3.49353C4.05282 2.37318 5.41893 1.63384 6.91071 1.39882C8.40248 1.16379 9.92973 1.44728 11.2378 2.20201M5.95598 7.26265L7.93665 9.24333L14.5389 2.64106" stroke="#008000" stroke-width="1.32045" stroke-linecap="round" stroke-linejoin="round"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_2491_91400">
                                            <rect width="15.8454" height="15.8454" fill="white"/>
                                        </clipPath>
                                    </defs>
                                </svg>
                            </div>
                            <div style="color: #28533A;">
                                <h5 style="font-size: 1rem; font-weight: 500;">6 Years</h5>
                                <small>Tax Coverage</small>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div 
                            class="stat-card dark"
                            data-aos="zoom-in"
                            data-aos-delay="300">
                            <div class="icon-wrapper">
                                <svg class="icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_2491_91400)">
                                        <path d="M14.4075 6.60242C14.7091 8.08218 14.4942 9.62059 13.7987 10.9611C13.1032 12.3016 11.9692 13.3632 10.5858 13.9688C9.2024 14.5744 7.65317 14.6874 6.1965 14.289C4.73982 13.8906 3.46375 13.0049 2.58108 11.7795C1.69841 10.5542 1.26251 9.06324 1.34605 7.55538C1.4296 6.04752 2.02755 4.61388 3.04019 3.49353C4.05282 2.37318 5.41893 1.63384 6.91071 1.39882C8.40248 1.16379 9.92973 1.44728 11.2378 2.20201M5.95598 7.26265L7.93665 9.24333L14.5389 2.64106" stroke="#00FF00" stroke-width="1.32045" stroke-linecap="round" stroke-linejoin="round"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_2491_91400">
                                            <rect width="15.8454" height="15.8454" fill="white"/>
                                        </clipPath>
                                    </defs>
                                </svg>
                            </div>
                            <div>
                                <h5 style="font-size: 1rem; font-weight: 500;">40 Questions</h5>
                                <small>Answered</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="faq-section">
    <div class="container">
        <div class="faq-grid">
            <!-- Sidebar -->
            <aside>
                <div class="pt-2 sticky-top z-1">
                    <h5 class="fw-bold mb-4" style="color: #3C3F64;">
                        QUICK NAVIGATION
                    </h5>
                    <div class="sideNav">
                        <ng-container *ngFor="let item of sideNavItems; let i = index">
                            <div class="sideNav__item"
                                routerLink="/vaids"
                                
                                (click)="scrollIntoView(item.id)"
                                [class.active]="activeSection === item.id"
                                data-aos="fade-right"
                                data-aos-offset="200"
                                [attr.data-aos-delay]="100 * i"
                            >
                                <div class="d-flex align-items-center justify-content-start gap-3">
                                    <div class="badge"><span>{{ item.badge }}</span></div>
                                    <p class="mb-0" style="white-space: nowrap;">{{ item.label }}</p>
                                </div>

                                <span>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M7.78125 3.24121L12.3203 7.78027L7.78125 12.3193" stroke="currentColor" stroke-width="1.11161" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </span>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </aside>

            <!-- Content -->
            <main>
                <!-- Search -->
                <form 
                    [formGroup]="searchForm" 
                    class="input-group mb-5 shadow-sm" 
                    style="position: sticky; top: 0; z-index: 10;"
                    data-aos="fade-down"
                    data-aos-delay="100">
                    <span class="input-group-text bg-white border-end-0 pe-0">
                        <svg style="height: 1.2rem; width: 1.2rem;" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14.5063 13.7374L12.2147 11.4969V11.4969L12.161 11.4152C12.0611 11.3158 11.9246 11.2598 11.782 11.2598C11.6395 11.2598 11.503 11.3158 11.4031 11.4152V11.4152C9.45559 13.2019 6.4547 13.299 4.39061 11.6422C2.32651 9.98529 1.83972 7.08859 3.25306 4.87312C4.66641 2.65766 7.54132 1.81091 9.97117 2.89443C12.401 3.97796 13.6318 6.65553 12.8473 9.1514C12.7908 9.33171 12.837 9.52779 12.9684 9.66578C13.0999 9.80378 13.2967 9.86271 13.4846 9.8204C13.6726 9.77808 13.8232 9.64094 13.8797 9.46063V9.46063C14.8175 6.49877 13.4011 3.31138 10.5467 1.96038C7.69227 0.609382 4.2565 1.50022 2.46197 4.05662C0.667451 6.61301 1.05272 10.0678 3.36856 12.186C5.68439 14.3042 9.23579 14.4503 11.7254 12.5296L13.7544 14.5134C13.9639 14.7173 14.3027 14.7173 14.5123 14.5134C14.7216 14.3065 14.7216 13.9734 14.5123 13.7665V13.7665L14.5063 13.7374Z" fill="#667085"/>
                        </svg>
                    </span>
                    <input
                        type="text"
                        class="form-control border-start-0 py-3"
                        placeholder="Search all questions"
                        formControlName="search"
                    >
                </form>

                <!-- ======================= -->
                <div class="accordion" [id]="'faqAccordion'">
                    <ng-container *ngFor="let faq of faqs; let i = index">
                        <section [id]="faq.id" class="mb-5" style="scroll-margin-top: 3.5rem;">
                            <h2 class="h3 fw-bold">
                                {{ faq.header }}
                            </h2>

                            <p class="text-secondary">
                                {{ faq.subHeader }}
                            </p>

                            <div>
                                <div
                                    class="accordion-item"
                                    *ngFor="let qa of faq.questionsAndAnswers; let j = index"
                                >
                                    <h2 class="accordion-header">
                                        <button
                                            class="accordion-button collapsed d-flex align-items-center justify-content-start gap-3"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            [attr.data-bs-target]="'#' + faq.id + '-' + j"
                                            aria-expanded="true"
                                            [attr.aria-controls]="faq.id + '-' + j"
                                        >
                                        <span style="color: #c0c0c7;">
                                            Q{{ j + 1 }}
                                        </span>
                                        <span style="color: #5A6F8C;">
                                            {{ qa.question }}
                                        </span>
                                        </button>
                                    </h2>

                                    <div
                                        class="accordion-collapse collapse fs-14"
                                        [ngClass]="{show: i === 0 && j === 0}"
                                        [id]="faq.id + '-' + j"
                                        [attr.data-bs-parent]="'#faqAccordion'"
                                    >
                                        <div class="accordion-body pt-1">
                                            <p class="mb-2">
                                                {{ qa.answer }}
                                            </p>
                                            <ng-container *ngFor="let child of qa.children">
                                                <div class="mt-2 d-flex align-items-center justify-content-start gap-2">
                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <g clip-path="url(#clip0_2491_91334)">
                                                            <path d="M14.535 6.66666C14.8395 8.16086 14.6225 9.71428 13.9203 11.0679C13.218 12.4214 12.073 13.4934 10.6761 14.1049C9.27913 14.7164 7.71479 14.8305 6.24391 14.4282C4.77302 14.026 3.4845 13.1316 2.59323 11.8943C1.70195 10.657 1.26179 9.15148 1.34615 7.62892C1.43051 6.10635 2.0343 4.65872 3.05681 3.52744C4.07932 2.39616 5.45876 1.64961 6.96509 1.4123C8.47141 1.17498 10.0136 1.46123 11.3344 2.22333M6.0013 7.33301L8.0013 9.33301L14.668 2.66634" stroke="#05A053" stroke-width="1.5" stroke-linecap="round"/>
                                                        </g>
                                                        <defs>
                                                            <clipPath id="clip0_2491_91334">
                                                                <rect width="16" height="16" fill="white"/>
                                                            </clipPath>
                                                        </defs>
                                                    </svg>
                                                    <p class="mb-0">
                                                        {{ child }}
                                                    </p>
                                                </div>
                                            </ng-container>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </ng-container>
                </div>
            </main>
        </div>
    </div>
</section>

<section class="cta-section">
    <div class="container">
        <div class="cta-grid">
            <div></div>
            <div 
                class="cta-card rounded-5 overflow-hidden"
                data-aos="fade-down"
                data-aos-delay="100">
                <div class="d-flex align-items-center justify-content-between gap-5" style="padding: 47px 40px;">
                    <!-- Left -->
                    <div 
                        style="width: 13rem;"
                        data-aos="zoom-out"
                        data-aos-delay="300">
                        <img
                            src="/assets/svg/vaids-illustration-2.svg"
                            class="img-fluid"
                            alt="Support">
                    </div>

                    <!-- Right -->
                    <div>
                        <h2 
                            class="display-6 fw-bold fs-24 mb-3 text-white"
                            data-aos="fade-down"
                            data-aos-delay="200">
                            Ready to Regularise Your Tax Position?
                        </h2>
                        <p 
                            class="text-white mb-4"
                            data-aos="fade-down"
                            data-aos-delay="300">
                            Visit the <span class="fw-bold">VAIDS Unit</span> at AIRS Headquarters, Awka, or any designated satellite centre across all 21 LGAs.
                        </p>
                        <div class="d-flex flex-wrap gap-3">
                            <button 
                                routerLink="/user/vaids" 
                                class="btn btn-lg px-4 py-2 d-flex align-items-center justify-content-between gap-2 fw-bold fs-15"
                                style="background-color: #D29226; color: #024423;"
                                data-aos="fade-down"
                                data-aos-delay="400">
                                <p class="mb-0">Get Started Now</p>
                                <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3.39844 8.15803H12.9176M8.15803 12.9176L12.9176 8.15803L8.15803 3.39844" stroke="#024423" stroke-width="1.16561" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </button>
                            <button 
                                routerLink="/user/vaids" 
                                class="btn btn-lg px-4 py-2 d-flex align-items-center justify-content-between gap-2 fw-bold fs-15"
                                style="background-color: transparent; color: #D29226; border-color: #D29226;"
                                data-aos="fade-down"
                                data-aos-delay="500">
                                <p class="mb-0">Contact AIRS</p>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<app-footer></app-footer>